<template>
    <div class="container" :class="[{flip: flipBackground},color]">
        <div class="header">
            <span v-if="icon" :class="[icon, 'icon']"></span>
            <span class="title">{{title}}</span>
            <span v-tooltip.right="infoText" v-if="infoText && infoText !== ''" class="icon-info icon" ></span>
        </div>
        <div class="body">
            <span class="value">{{numberValue}}</span>
            <span v-if="gain" class="gain" :class="{pink: color === 'blue', blue: color === 'pink'}">{{gain}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DashboardKPIBox",
        props: {
            title: {
                type: String,
                required: true
            },
            value: {
                type: [Number, String],
                required: true
            },
            icon: {
                type: String,
                required: false
            },
            color: {
                type: String, //[pink, blue]
                default: 'pink'
            },
            infoText: {
                type: String,
                require: false
            },
            gain: {
                type: String,
                required: false
            },
            flipBackground:{
                type: Boolean,
                required: false
            }
        },
        computed:{
            numberValue: function (){
                if(typeof this.value === 'number'){
                    return this.value.toLocaleString('de-DE');
                }
                return this.value;
            }
        },

    }
</script>

<style lang="scss" scoped>
    .container {
        display: flex;
        flex-flow: column;
        padding: 1rem;
        width: 100%;
        height: 100px;
        border-radius: 20px;

        &.pink {
            background: rgb(117, 43, 119);
            background: -moz-linear-gradient(135deg, $purple 0%, $pink 100%);
            background: -webkit-linear-gradient(135deg, $purple 0%, $pink 100%);
            background: linear-gradient(135deg, $purple 0%, $pink 100%);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#752b77", endColorstr="#d70364", GradientType=1);

            &.flip{
                background: rgb(117, 43, 119);
                background: -moz-linear-gradient(135deg, $pink 0%, $purple 100%);
                background: -webkit-linear-gradient(135deg, $pink 0%, $purple 100%);
                background: linear-gradient(135deg, $pink 0%, $purple 100%);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#d70364", endColorstr="#752b77", GradientType=1);
            }
        }

        &.blue {
            background: rgb(117, 43, 119);
            background: -moz-linear-gradient(135deg, $purple 0%, $blue 100%);
            background: -webkit-linear-gradient(135deg, $purple 0%, $blue 100%);
            background: linear-gradient(135deg, $purple 0%, $blue 100%);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#752b77", endColorstr="#00b6ed", GradientType=1);
            &.flip{
                background: rgb(117, 43, 119);
                background: -moz-linear-gradient(135deg, $blue 0%, $purple 100%);
                background: -webkit-linear-gradient(135deg, $blue 0%, $purple 100%);
                background: linear-gradient(135deg, $blue 0%, $purple 100%);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00b6ed", endColorstr="#752b77", GradientType=1);
            }
        }
    }

    .icon {
        color: $pink;
        font-size: 1.6rem;
        padding-right: 10px;
    }

    .icon-info.icon{
        color: white;
        margin-left: auto;
        font-size: 1.5rem;
        cursor: pointer;
    }

    .header, .body{
        color: #fff;
    }

    .header{
        display: flex;
        flex-flow: wrap;
        align-items: center;
    }

    .title{
        font-weight: 500;
        text-transform: uppercase;
        font-size: 0.9rem;
        top:-5px;
        position: relative;
    }

    .value{
        font-size: 2rem;
        font-weight: 500;
    }

    .gain{
        font-size: 0.9em;
        padding-left: 10px;
        font-weight: 500;

        &.pink{
            color: $pink;
        }
        &.blue{
            color: $blue;
        }
    }
    @media (min-width: 768px) and (max-width: 1024px) {
        .icon {
            font-size: 1.2rem;
        }

        .icon-info.icon{
            font-size: 1.2rem;
        }

        .title{
            font-size: 0.7rem;
        }

        .value{
            font-size: 1.5rem;
        }
    }


</style>